import request from '@/utils/request'

// 兼容后端可能返回的三种列表结构：
// 1) res.data 直接是数组，total/records 在 res 顶层
// 2) res.data = { total, records, data: [...] } 嵌套结构
// 3) res.data = { "0": {...}, "1": {...} } 数字键对象（非真数组）
function normalizeListResponse(res) {
  let dataArray = res.data

  if (!Array.isArray(dataArray) && dataArray && typeof dataArray === 'object') {
    if (Array.isArray(dataArray.data)) {
      // 情况 2：嵌套结构
      const inner = dataArray
      return {
        data: inner.data,
        total: Number(inner.total || inner.records || res.total || res.records || 0)
      }
    }
    // 情况 3：数字键对象，按 key 排序后转数组
    const numericKeys = Object.keys(dataArray).filter(k => !isNaN(k))
    dataArray = numericKeys.length > 0
      ? numericKeys.sort((a, b) => Number(a) - Number(b)).map(k => dataArray[k])
      : []
  }

  if (!Array.isArray(dataArray)) dataArray = []

  return {
    data: dataArray,
    total: Number(res.total || res.records || 0)
  }
}

// 查询工单列表
export function listInspectionWorks(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.listInspectionWorks',
      method: 'get',
      params: params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(normalizeListResponse(res))
      } else {
        reject(new Error(res.msg || '获取工单列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 派单
export function dispatchInspectionWork(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.dispatchInspectionWork',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '派单失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 办理完成
export function completeInspectionWork(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.completeInspectionWork',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '办理完成失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 结束工单
export function endInspectionWork(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.endInspectionWork',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '结束工单失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
